import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'
import type { RefreshToken } from 'context/AuthContext/AuthContext.types'

export const axiosPatch = async <T>(
  token: string,
  refreshToken: RefreshToken,
  endpoint: string,
  body: any,
  options?: AxiosRequestConfig
): Promise<T | { error: AxiosResponse | undefined } | undefined> => {
  try {
    const res = await axios.patch(`${process.env.REACT_APP_API_URL}/${endpoint}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        ...options
      })

    return res.data
  } catch (err) {
    if (axios.isAxiosError(err)) {
      if (err?.response?.status === 401) {
        refreshToken().then(res => { console.log(res) }).catch(err => { console.log(err) })
      }
      return {
        error: err.response
      }
    }
  }
}
